import React from "react"
import {
  Container,
  List,
  MobileFlex,
  MobileStoresWrapper,
  MobileSocialListItem,
  FooterLink,
  Brand
} from "./elements"
import { Box, Flex } from "reflexbox/styled-components"
import Collapsible from "react-collapsible"
import MobileListHeader from "./MobileListHeader"
import { useTranslation } from "react-i18next"
import ListItem from "./ListItem"
import { FooterContext } from "./Footer"

import appStoreLogo from "../../../static/img/footer/appstore.svg"
import playStoreLogo from "../../../static/img/footer/playstore.svg"
import TranslateComponentItem from "./TranslateComponentItem"
import ComposedListItem from "./ComposedListItem"
import {
  WhatsappIcon,
  InstagramIcon,
  FacebookIcon,
  TwitterIcon,
  EmailIcon
} from "./icons"

const FooterMobile = ({ secondary }) => {
  const { t } = useTranslation()
  return (
    <FooterContext.Provider value={{ secondary }}>
      <Container gradient={secondary}>
        <Flex sx={{ color: "text" }} py={["50px"]}>
          <Box p={2}>
            <List>
              <Collapsible
                transitionTime={200}
                trigger={<MobileListHeader title={t("about")} />}
                triggerWhenOpen={
                  <MobileListHeader title={t("about")} open={true} />
                }
              >
                <List>
                  <FooterLink to="/more">
                    <ListItem subitem={true} title={t("findMore")} />
                  </FooterLink>
                  {/* <FooterLink to="/benefits">
                    <ListItem subitem={true} title={t("benefits")} />
                  </FooterLink> */}
                  <FooterLink to="/join">
                    <ListItem subitem={true} title={t("join")} />
                  </FooterLink>
                  <FooterLink to="/driver">
                    <ListItem subitem={true} title={t("driver")} />
                  </FooterLink>
                </List>
              </Collapsible>
              <Collapsible
                transitionTime={200}
                trigger={<MobileListHeader title={t("help")} />}
                triggerWhenOpen={
                  <MobileListHeader title={t("help")} open={true} />
                }
              >
                <List>
                  <FooterLink to="/help-center">
                    <ListItem subitem={true} title={t("help")} />
                  </FooterLink>
                </List>
              </Collapsible>
              <Collapsible
                transitionTime={200}
                trigger={<MobileListHeader title={t("contact")} />}
                triggerWhenOpen={
                  <MobileListHeader title={t("contact")} open={true} />
                }
              >
                <List>
                  <FooterLink to="/contact">
                    <ListItem subitem={true} title={t("contact")} />
                  </FooterLink>
                  <FooterLink to="/corporate">
                    <ListItem subitem={true} title={t("corporate")} />
                  </FooterLink>
                </List>
              </Collapsible>
              <Collapsible
                transitionTime={200}
                trigger={<MobileListHeader title={t("terms")} />}
                triggerWhenOpen={
                  <MobileListHeader title={t("terms")} open={true} />
                }
              >
                <List>
                  <FooterLink to="/terms-drivers">
                    <ListItem subitem={true} title={t("drivers")} />
                  </FooterLink>
                  <FooterLink to="/terms-users">
                    <ListItem subitem={true} title={t("passengers")} />
                  </FooterLink>
                  <FooterLink to="/policies">
                    <ListItem subitem={true} title={t("policies")} />
                  </FooterLink>
                </List>
              </Collapsible>

              <MobileFlex>
                <Box width={2 / 10} mt={["2rem", 0]}>
                  <TranslateComponentItem mobile={true} />
                </Box>
                <Box width={8 / 10}>
                  <ComposedListItem
                    title={
                      <MobileStoresWrapper>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://apps.apple.com/py/app/muv/id1254658756"
                        >
                          <img src={appStoreLogo} width="85%" alt="appStore" />
                        </a>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://play.google.com/store/apps/details?id=com.muv.customer&hl=es_PY"
                        >
                          <img
                            src={playStoreLogo}
                            width="85%"
                            alt="playStore"
                          />
                        </a>
                      </MobileStoresWrapper>
                    }
                  />
                  <MobileSocialListItem>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://twitter.com/app_muv"
                    >
                      <TwitterIcon />
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/app.muv"
                    >
                      <FacebookIcon />
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.instagram.com/app.muv/?hl=es-la"
                    >
                      <InstagramIcon />
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://api.whatsapp.com/send?phone=595971688688"
                    >
                      <WhatsappIcon />
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="mailto:info@muv-app.co"
                    >
                      <EmailIcon />
                    </a>
                    <img alt="" />
                  </MobileSocialListItem>
                </Box>
              </MobileFlex>
            </List>
            <Brand secondary={secondary}>® Click S.A.</Brand>
          </Box>
        </Flex>
      </Container>
      </FooterContext.Provider>
  )
}

export default FooterMobile
